import { useEffect, useState } from 'react';

export const useTextTruncationDetection = (textRef: React.RefObject<HTMLElement | null>) => {
	const [isTruncated, setIsTruncated] = useState(false);

	useEffect(() => {
		const element = textRef.current;
		if (!element) {
			return;
		}

		const checkTruncation = () => {
			const isTextTruncated = element.scrollWidth > element.clientWidth;
			setIsTruncated(isTextTruncated);
		};

		// Initial check
		checkTruncation();

		const resizeObserver = new ResizeObserver(checkTruncation);
		resizeObserver.observe(element);

		return () => {
			resizeObserver.disconnect();
		};
	}, [isTruncated, textRef]);

	return { isTruncated };
};
